import axios from "axios";
import { localStorageItem } from "../../utils/LocalStorage";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { APP_CONFIGURATION_KEYS } from "../../utils/Constant";

const API_PATH = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.INPATIENT_URL] || process.env.REACT_APP_INPATIENT_API_URL;

export const getDsBenhNhan = (params: any) => {
    let url = API_PATH + "/medical-record/record/patient/treatment";
    return axios.get(url, { params });
}

// dich vu
export const getThongTinPhieuChiDinh = (params: { orderGroupId: string }) => {
    let url = API_PATH + "/service-prescription/paraclinical";
    return axios.get(url, { params });
}

export const fetchChiDinhDichVu = (data: any, callback?: (dataCb: any) => void) => {
    let url = API_PATH + "/service-prescription/paraclinical";
    return axios.post(url, data, { callback });
}

export const updatePhieuChiDinh = (data: any, callback?: (dataCb: any) => void) => {
    let url = API_PATH + "/service-prescription/paraclinical";
    return axios.put(url, data, { callback });
}

// thuoc
export const getThongTinPhieuThuoc = (params: { medicalItemGroupId: string }) => {
    let url = API_PATH + "/service-prescription/medical-item";
    return axios.get(url, { params });
}

export const fetchKeThuoc = (data: any) => {
    let url = API_PATH + "/service-prescription/medical-item";
    return axios.post(url, data);
}

export const updateKeThuoc = (data: any) => {
    let url = API_PATH + "/service-prescription/medical-item";
    return axios.put(url, data);
}

// phieu dieu tri grouped by date
export const getTreatmentSheetsGroupedByDate = (params: { treatmentId: string }) => {
    let url = API_PATH + "/treatment-sheets/grouped-by-date";
    return axios.get(url, { params });
}